module.exports = __webpack_public_path__ + "static/img/logo13.08443f88.png";